import { Avatar, Space } from "antd"

interface SmallProfileCardProps {
    avatar?: string;
    name?: string;
    subTitle?: string;
    initials?: string;
}

const SmallProfileCard: React.FC<SmallProfileCardProps> = ({
    name,
    avatar,
    subTitle,
    initials
}) => {

    return <Space direction="horizontal" className="max-w-full overflow-hidden">
        {avatar && <Avatar src={`${process.env.FILE_URL}${avatar}`} shape="circle" size={"default"} />}
        {!avatar && <Avatar shape="circle" size={"default"} style={{ backgroundColor: '#f0f0f0', color: '#000' }}>{initials || name?.charAt(0)}</Avatar>}
        <Space
            direction="vertical"
            size={0}
            className="overflow-hidden max-w-full"
        >
            <h4
                className="font-semibold m-0 truncate whitespace-nowrap overflow-hidden max-w-full"
                title={name}
            >
                {name}
            </h4>
            <h4
                className="m-0 truncate whitespace-nowrap overflow-hidden max-w-full"
                title={subTitle}
            >
                {subTitle}
            </h4>
        </Space>
    </Space>
}

export default SmallProfileCard;